export default __webpack_public_path__ + "static/media/backgroundLogoBankzz.995288b9.svg";